/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/neg.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * Returns the negation of the argument.
 */
const definition: OperatorDefinition = {
  operator: '-',
  name: 'neg',
  titleName: 'negate',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'date_period',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_period',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'field',
          type: 'time_duration',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'time_duration',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
